import $ from 'jquery';

const showExpander = (uniq) => {
  const $uniq = $(uniq);
  const $targetSelector = $($uniq.data('parent')).children('.show-more-expander');
  const $arrowChanger = $uniq.children('.control-arrow');
  const $showAllTextChanger = $uniq.children('span');
  if ($targetSelector.is(':hidden')) {
    $uniq.attr('data-ct-ignore', true);
    $targetSelector.slideDown();
    $arrowChanger.removeClass('right').addClass('up');
    $showAllTextChanger.html(`${$uniq.attr('expanded-text')}`);
  } else {
    $uniq.removeAttr('data-ct-ignore');
    $targetSelector.slideUp();
    $arrowChanger.removeClass('up').addClass('right');
    $showAllTextChanger.html(`${$uniq.attr('collapsed-text')}`);
  }
};

export const initShowExpander = () => {
  $('.expand-control-text').on('click', (e) => {
    e.preventDefault();
    showExpander(e.currentTarget);
  });
};

export default () => {
  initShowExpander();
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/feature-topics-grid.js